import { useNavigate } from "react-router-dom"
import { LocationForm } from "./location-form"
import { TablePageLayout } from "~/layouts/table-page-layout"
import { useSafeMutation } from "~/common/use-safe-mutation"
import { gql } from "~/__generated__"
import { useToast } from "~/ui/use-toast"
import { LocationStatus } from "~/__generated__/graphql"

const createLocationMutation = gql(/* GraphQL */ `
  mutation CreateLocation(
    $name: String!
    $status: LocationStatus!
    $websiteUrl: String
    $googleMapsUrl: String
    $latitude: Float
    $longitude: Float
    $streetAddress: String
    $streetAddress2: String
    $city: String
    $stateProvince: String
    $postalCode: String
    $country: String
    $formattedAddress: String
    $placeId: String
    $administrativeAreaLevel1: String
    $administrativeAreaLevel2: String
    $neighborhood: String
    $phone: String
    $timeZone: String
  ) {
    locationCreate(
      input: {
        name: $name
        status: $status
        websiteUrl: $websiteUrl
        googleMapsUrl: $googleMapsUrl
        latitude: $latitude
        longitude: $longitude
        streetAddress: $streetAddress
        streetAddress2: $streetAddress2
        city: $city
        stateProvince: $stateProvince
        postalCode: $postalCode
        country: $country
        formattedAddress: $formattedAddress
        placeId: $placeId
        administrativeAreaLevel1: $administrativeAreaLevel1
        administrativeAreaLevel2: $administrativeAreaLevel2
        neighborhood: $neighborhood
        phone: $phone
        timeZone: $timeZone
      }
    ) {
      location {
        id
        name
        status
        websiteUrl
        googleMapsUrl
        latitude
        longitude
        streetAddress
        streetAddress2
        city
        stateProvince
        postalCode
        country
        formattedAddress
        placeId
        administrativeAreaLevel1
        administrativeAreaLevel2
        neighborhood
        phone
        timeZone
      }
    }
  }
`)

export const LocationNewScreen = () => {
  const navigate = useNavigate()
  const { toast } = useToast()
  const [createLocation] = useSafeMutation(createLocationMutation)

  return (
    <TablePageLayout>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl">Suggest a location</h1>
      </div>
      <hr className="my-4 border-0 border-b" />
      <LocationForm
        onSubmit={async (formData) => {
          console.log("Submitting formData:", formData)
          const { data: result, errors } = await createLocation({
            variables: {
              name: formData.name,
              status: formData.status as LocationStatus,
              websiteUrl: formData.websiteUrl,
              googleMapsUrl: formData.googleMapsUrl,
              latitude: formData.latitude,
              longitude: formData.longitude,
              streetAddress: formData.streetAddress,
              streetAddress2: formData.streetAddress2,
              city: formData.city,
              stateProvince: formData.stateProvince,
              postalCode: formData.postalCode,
              country: formData.country,
              formattedAddress: formData.formattedAddress,
              placeId: formData.placeId,
              administrativeAreaLevel1: formData.administrativeAreaLevel1,
              administrativeAreaLevel2: formData.administrativeAreaLevel2,
              neighborhood: formData.neighborhood,
              phone: formData.phone,
              timeZone: formData.timeZone,
            },
          })

          if (result?.locationCreate?.location && !errors) {
            toast({
              title: "Suggestion Received",
              description: "Thank you for your suggestion, we'll review that location!",
            })
            navigate("/locations")
          }
        }}
        mode="create"
      />
    </TablePageLayout>
  )
}
